export class PageChangedEvent {
  constructor(public currentPage: number, public pageSize: number) {}
}
